module.exports = __webpack_public_path__ + "img/CompScope_Mag_4_Focus_2.fec19c92.png";